export default {
  title: 'Articles',
  order_note: 'Note de commande',
};
